import React, { Fragment } from "react";
import { Circle, Rect, Group } from "react-konva";
import { angleData } from "./angleData";
import { ClockPoint } from "./ClockPoint";
var circleAngles = Object.keys(angleData).map(function (angleStr) {
  return parseFloat(angleStr);
}).sort(function (a, b) {
  return a - b;
});
export var ClockFace = function ClockFace(_ref) {
  var clockRadius = _ref.clockRadius,
      inactiveRange = _ref.inactiveRange,
      _ref$zeroSeparator = _ref.zeroSeparator,
      zeroSeparator = _ref$zeroSeparator === void 0 ? false : _ref$zeroSeparator;
  return /*#__PURE__*/React.createElement(Group, {
    rotation: -90
  }, circleAngles.map(function (angle, index) {
    return angle === 0 && zeroSeparator ? /*#__PURE__*/React.createElement(ClockPoint, {
      as: Rect,
      key: angle,
      angle: angle,
      clockRadius: clockRadius,
      fill: "#4d9adf",
      cornerRadius: 2,
      width: 24,
      height: 4,
      offsetX: 12,
      offsetY: 2
    }) : /*#__PURE__*/React.createElement(ClockPoint, {
      as: Circle,
      key: angle,
      angle: angle,
      clockRadius: clockRadius,
      fill: "#4d9adf",
      opacity: inactiveRange && angle >= inactiveRange[0] && angle <= inactiveRange[1] ? 0.3 : 1,
      radius: index % 2 === 0 ? 4.5 : 3
    });
  }));
};